/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string, func } from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import mbpLogger from 'mbp-logger';

import getAutoSuggest from '../../../../gql/queries/getAutoSuggest';
import SearchDropdown from './SearchDropdown';

/**
 *
 * @param {*} str take the input from search box
 * @return string
 * @example input val test"s it will return test\"s
 *  @example input val \ it will return ' '
 */
const escapeDoubleQuotes = (str) => str.replace(/"/g, '\\"');

const ElasticSearchSuggestions = ({
    track, phrase, brand, clearSearch, concatSearchTerm, cleanTerm, setSearchResult,
}) => {
    let response = null;
    const displayNone = false;
    const getPhraseData = phrase.replace(/\\/g, ' ');
    const FIND_SUGGESTIONS = getAutoSuggest({ brand, phrase: encodeURIComponent(escapeDoubleQuotes(getPhraseData)) });
    const { error, data } = useQuery(FIND_SUGGESTIONS, [phrase]);

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: error,
            message: `Failed to fetch content data for: auto suggestions from elastic search(ElasticSearchSuggestions) on brand ${brand}`,
        });
    }
    setSearchResult(data);
    if ((data?.autoSuggest?.products?.length > 0 || data?.autoSuggest?.phrases?.length >= 0)) {
        response = (displayNone && <SearchDropdown cleanTerm={cleanTerm} concatSearchTerm={concatSearchTerm} track={track} clearSearch={clearSearch} phrase={phrase} suggestions={data.autoSuggest} />);
    }
    return response;
};

ElasticSearchSuggestions.propTypes = {
    phrase: string.isRequired,
    brand: string.isRequired,
    clearSearch: func.isRequired,
    track: func.isRequired,
    concatSearchTerm: func.isRequired,
    cleanTerm: func,
};

ElasticSearchSuggestions.defaultProps = {
    cleanTerm: () => {},
};

export default ElasticSearchSuggestions;
